import Immutable from 'immutable'
import type { Map } from 'immutable'
import { createSelector } from 'reselect'

type PartialState = {
  menuRecipes: Immutable.List<any>
}

type PartialStore = {
  recipes: Map<string, unknown>
}

export const getMenuRecipes = (state: PartialState) => state.menuRecipes

const getRecipesFromStore = ({ recipes }: PartialStore) => ({
  recipes,
})

export const getStoreRecipes = createSelector(getRecipesFromStore, ({ recipes }) => recipes)
